import { type Page } from '@ps/web-core-store';
import React from 'react';

import StarsLayoutBase from './StarsLayoutBase';
import styles from './StarsLayoutV3.scss';

const StarsLayoutV3: React.FC<Page> = (page) => (
  <div className="test v3">
    <StarsLayoutBase
      classes={{
        cmsNav: {
          root: styles.cmsNavRoot,
          container: styles.cmsNavContainer,
          nav: styles.cmsNav,
          navItem: styles.cmsNavItem
        },
        sideNav: styles.sideNav,
        sideNavContainer: styles.sideNavContainer
      }}
      showSidenav
      {...page}
    />
  </div>
);

export default StarsLayoutV3;
